import { HTTP_STATUS } from "../../api/HttpProtocol";

type Failure = { status?: number; result?: { message?: string; committedMessageId?: string }; detail?: { message?: string } };

export function committedChatMessageId(error: unknown): string | undefined {
  return (error as Failure | undefined)?.result?.committedMessageId;
}

export function chatErrorMessage(error: unknown, fallback: string): string {
  const failure = error as Failure | undefined;
  const message = failure?.result?.message ?? failure?.detail?.message;
  if (message) return message;
  switch (failure?.status) {
    case HTTP_STATUS.unauthorized:
      return "Sign in to continue this chat.";
    case HTTP_STATUS.forbidden:
      return "Chat access is unavailable.";
    case HTTP_STATUS.notFound:
      return "Chat is unavailable in the saved App for this environment.";
    case HTTP_STATUS.tooManyRequests:
      return "Chat is busy. Please wait before retrying.";
    case HTTP_STATUS.serviceUnavailable:
      return "Chat is temporarily unavailable. Retry the original request.";
    default:
      return error instanceof Error ? error.message : fallback;
  }
}

export function chatSendWasRejected(error: unknown): boolean {
  const rejectedStatuses: readonly number[] = [
    HTTP_STATUS.badRequest,
    HTTP_STATUS.unauthorized,
    HTTP_STATUS.forbidden,
    HTTP_STATUS.notFound,
    HTTP_STATUS.payloadTooLarge,
    HTTP_STATUS.unprocessableEntity,
  ];
  return rejectedStatuses.includes((error as Failure | undefined)?.status ?? 0);
}
